module.exports = __webpack_public_path__ + "img/WechatIMG15600.b32c72d6.jpg";